import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const FileDatabase = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M16 2C10.3926 2 6 4.6355 6 8V24C6 27.3645 10.3926 30 16 30C21.6074 30 26 27.3645 26 24V8C26 4.6355 21.6074 2 16 2ZM10.1217 5.33862C11.675 4.475 13.7625 4 16 4C18.2375 4 20.325 4.475 21.8783 5.33862C23.2266 6.0875 24 7.05775 24 8C24 8.94225 23.2266 9.9125 21.8783 10.6614C20.325 11.525 18.2375 12 16 12C13.7625 12 11.675 11.525 10.1217 10.6614C8.77337 9.9125 8 8.94225 8 8C8 7.05775 8.77337 6.0875 10.1217 5.33862ZM21.8783 26.6614C20.325 27.525 18.2375 28 16 28C13.7625 28 11.675 27.525 10.1217 26.6614C8.77337 25.9125 8 24.9423 8 24V19.641C9.81012 21.083 12.6934 22 16 22C19.3066 22 22.1899 21.083 24 19.641V24C24 24.9423 23.2266 25.9125 21.8783 26.6614ZM21.8783 18.6614C20.325 19.525 18.2375 20 16 20C13.7625 20 11.675 19.525 10.1217 18.6614C8.77337 17.9125 8 16.9423 8 16V11.641C9.81012 13.083 12.6934 14 16 14C19.3066 14 22.1899 13.083 24 11.641V16C24 16.9423 23.2266 17.9125 21.8783 18.6614Z" />
	</svg>
);

export default FileDatabase;
